module.exports = __webpack_public_path__ + "img/ring_y_i_0_1@2x.9c24170b.png";